export default function MessageIcon({
  width = 16,
  height = 16,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3362 6.83334C10.0602 6.83334 9.90456 6.83334 9.77063 6.84234C7.84343 6.97228 6.30969 8.46168 6.17592 10.3331C6.16662 10.4633 6.16662 10.6144 6.16663 10.8823V10.9145C6.16662 11.1824 6.16662 11.3335 6.17592 11.4637C6.30969 13.3351 7.84343 14.8245 9.77063 14.9544C9.90456 14.9635 10.0602 14.9635 10.3362 14.9635H10.9971C11.273 14.9635 11.4287 14.9635 11.5626 14.9544C12.0738 14.9199 12.5578 14.7897 12.9953 14.5819L15.0725 15.1667L14.5265 13.2746C14.8842 12.7489 15.1097 12.1303 15.1574 11.4637C15.1666 11.3335 15.1666 11.1823 15.1666 10.9145V10.8823C15.1666 10.6144 15.1666 10.4633 15.1574 10.3331C15.0236 8.46168 13.4898 6.97228 11.5626 6.84234C11.4287 6.83334 11.273 6.83334 10.9971 6.83334H10.3362Z"
        fill={color}
      />
      <path
        d="M9.02737 0.847424C8.82391 0.833337 8.58751 0.833337 8.16857 0.833344H7.16484C6.74591 0.833337 6.50953 0.833337 6.30607 0.847424C3.37964 1.05007 1.05061 3.37356 0.847488 6.29303C0.833368 6.496 0.833368 6.73181 0.833374 7.14974V7.19988C0.833368 7.61781 0.833368 7.85361 0.847488 8.05661C0.919848 9.09654 1.26226 10.0615 1.80543 10.8817L0.976288 13.8333L4.13059 12.921C4.69029 13.1942 5.30007 13.3815 5.94249 13.4658C5.60667 12.8872 5.39523 12.2287 5.34479 11.5231C5.33333 11.3627 5.33335 11.1843 5.33337 10.9445L5.33338 10.9145L5.33337 10.8523C5.33335 10.6125 5.33333 10.434 5.34479 10.2737C5.50951 7.96914 7.39137 6.16752 9.71464 6.01092C9.87704 5.99998 10.0584 5.99999 10.3069 6.00001L10.3362 6.00002L11.0265 6.00001C11.275 5.99999 11.4564 5.99998 11.6188 6.01092C12.7252 6.08551 13.7316 6.53323 14.5 7.23068C14.5 7.22054 14.5 7.21028 14.5 7.19988V7.14974C14.5 6.73181 14.5 6.496 14.4859 6.29303C14.2828 3.37356 11.9538 1.05007 9.02737 0.847424Z"
        fill={color}
      />
    </svg>
  );
}
